import type React from "react"

import { useState } from "react"
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog"
import { ScrollArea } from "@/components/ui/scroll-area"
import { Separator } from "@/components/ui/separator"
import { ModalHeader } from "@/components/molecules/ModalHeader/ModalHeader"
import { ContactInfoCard } from "@/components/molecules/ContactInfoCard/ContactInfoCard"

interface ResourceModalTemplateProps {
  title: string
  date: string
  trigger: React.ReactNode
  children: React.ReactNode
  className?: string
}

export function ResourceModalTemplate({ title, date, trigger, children, className = "" }: ResourceModalTemplateProps) {
  const [open, setOpen] = useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className={`max-w-4xl max-h-[80vh] p-0 ${className}`}>
        <ModalHeader title={title} date={date} onClose={handleClose} />
        <ScrollArea className="px-6 py-4 max-h-[60vh]">
          {children}
          <Separator className="my-6" />
          <ContactInfoCard />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}
